import accidentFA from './fa/fa.json'

const AccidentMessages = {
  fa: { ...accidentFA },
}

export default AccidentMessages
